import { render, staticRenderFns } from "./SupplyDemand.vue?vue&type=template&id=d59309ac&scoped=true"
import script from "./SupplyDemand.vue?vue&type=script&lang=js"
export * from "./SupplyDemand.vue?vue&type=script&lang=js"
import style0 from "./SupplyDemand.vue?vue&type=style&index=0&id=d59309ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59309ac",
  null
  
)

export default component.exports